/* eslint-disable no-template-curly-in-string */
import React, {useMemo} from 'react';
import {NavbarDefault} from 'components/core/navbar';
import {Container} from 'components/structure/Container';
import {Content} from 'components/structure/Content';
import Header from 'components/core/Header';
import {history} from 'constants/routes';
import Form from 'components/contexts/enterprises/Form';
import {useForm} from 'react-hook-form';
import {useDispatch, useSelector} from 'react-redux';
import * as yup from 'yup';
import useYupValidationResolver from 'hooks/useYupValidationResolver';
import {EnterprisesActions} from 'store/enterprises/enterprises.ducks';

const NewInvestor = () => {
  const dispatch = useDispatch();

  const {enterprisesRequests, error} = useSelector(
    ({enterprises}) => enterprises,
  );

  const validationSchema = useMemo(
    () =>
      yup.object({
        enterpriseName: yup.string().label("Enterprise's name").required(),
        investorName: yup.string().label("Investor's name").required(),
        email: yup.string().email().label('E-mail').required(),
      }),
    [],
  );
  const resolver = useYupValidationResolver(validationSchema);

  const {register, handleSubmit, errors} = useForm({resolver});

  const onSubmit = (data) => {
    dispatch(EnterprisesActions.createEnterprise(data));
  };
  return (
    <>
      <NavbarDefault active="enterprises" />
      <Content>
        <Container>
          <Header
            type="back"
            title="Register new enterprise + investor"
            onClickBack={() => history.goBack()}
          />
          <Form
            register={register}
            handleSubmit={handleSubmit}
            onSubmit={onSubmit}
            error={error}
            errors={errors}
            request={enterprisesRequests.CREATE_INVESTOR}
          />
        </Container>
      </Content>
    </>
  );
};

export default NewInvestor;
